module.exports = __webpack_public_path__ + "static/img/profile.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile.jpg
// module id = 57
// module chunks = 0